import { hasRolePrivilege } from "@/middleware/rolePermissions";

/**
 * Which Help Center a role reads: the one fact behind the Help Center link in
 * the support dialog, the pages a support reply may cite
 * (`lib/support/help-pages.js`) and the walkthrough Sabine offers
 * (`lib/support/walkthrough-suggestion.js`).
 *
 * It lives apart from `help-pages.js` because that file reads the public
 * support articles off disk, so a `"use client"` component cannot import it.
 * Nothing here touches the filesystem — it is safe on both sides.
 */

export const MEMBER_HELP_BASE = "/help/member";
export const ADMIN_HELP_BASE = "/help/admin";

// Admin help documents studio management; supervisors manage their team's
// assignments and content, so they read it too.
const ADMIN_HELP_ROLE = "supervisor";

export function canReadAdminHelp(role) {
  return hasRolePrivilege(role, ADMIN_HELP_ROLE);
}

/** Whether a Help Center href is one `role` should be pointed to. */
export function isHelpHrefForRole(href, role) {
  const isAdminHelp =
    href === ADMIN_HELP_BASE || String(href).startsWith(`${ADMIN_HELP_BASE}/`);
  return !isAdminHelp || canReadAdminHelp(role);
}

/**
 * The Help Center index to link someone with `role` to, labelled with the
 * heading that page renders so the link and its destination agree. An unknown
 * role gets member help: admin help is never offered on a guess.
 */
export function getHelpCenterLink(role) {
  return canReadAdminHelp(role)
    ? { href: ADMIN_HELP_BASE, label: "Admin Help Center" }
    : { href: MEMBER_HELP_BASE, label: "Member Help Center" };
}
